import ApplyInsurance from "../../../Pages/Insurance";

import { modalVariants } from "../../../Utils/constants";

export default function renderApplyInsurance(modalContext) {
  const { updateModalComponent, setModalClassName, setModalVariant } = modalContext;

  updateModalComponent(ApplyInsurance);
  setModalVariant(modalVariants.fullScreenDialog);
  setModalClassName("apply-insurance hide-header");
}
